import { L10nModule } from 'bernie-l10n';

function localization(locale: string): L10nModule {
  const mod = new L10nModule();

  mod.current = locale;
  mod.globalize = require(`eg-affiliate-products-localization/dist/bundle-${locale}`);

  return mod;
}

export { localization };
